/* eslint-disable */
import axios from 'axios';
function getProjectStatus() {
    axios
        .get('https://center-service.event1.cn/project?id=' + window.project)
        .then(res => {
            // console.log(localStorage.getItem('force_0704_ver'));
            // console.log('data', res.data, res.data.message.status);
            let d = res.data || res;
            // console.log('🚀 ~ Project:', d);
            switch (d.message.status) {
                case 20211:
                    creteConsole('该版本未上线', '--VC-TEXTGREEN', 20211);
                    break;
                case 20212:
                    // window['console']['log'] = () => {};
                    // creteConsole('该版本未上线', '--VC-TEXTGREEN', 20212);
                    if (
                        d.message.status_text.split('|')[1] !=
                        localStorage.getItem('vConsole_1yue_' + window.project)
                    ) {
                        // localStorage.clear();
                        localStorage.setItem(
                            'vConsole_1yue_' + window.project,
                            d.message.status_text.split('|')[1]
                        );
                        window.location.reload(true);
                    }
                    break;
                case 20213:
                    vSwitch.style.display = 'block';
                    creteConsole('该版本已下线', '--VC-CODE-STR-FG', 20213);
                    break;
                case 20214:
                    document.body.innerHTML = '';
                    document.write(
                        "<p style='text-align:center;margin-top:150px;'>项目已下线，如有需要请咨询商务经理 <a href='mailto:caiwenbin@1yue.com.cn'>caiwenbin@1yue.com.cn</a></p>"
                    );
                    break;
                default:
                    vSwitch.style.display = 'block';
                    creteConsole('项目状态异常', '--VC-RED', 0);
                    break;
            }
        })
        .catch(err => {
            console.log(err);
        });
}
getProjectStatus();

function creteConsole(TEXT, BGCOLOR, code) {
    let elm = document.createElement('script');
    elm.src = 'https://oss.eventnet.cn/H5/public/vconsole.min.js';
    document.head.appendChild(elm);
    elm.onload = () => {
        new VConsole({
            onReady() {
                let vs = document.querySelector('.vc-switch');
                vs.innerText = TEXT;
                vs.style.background = 'var(' + BGCOLOR + ')';
                vs.style.fontSize = '14px';
                vs.style.fontFamily = '微软雅黑';
                switch (code) {
                    case 20211:
                        vs.style.display = 'block';
                        break;
                    case 20213:
                        vs.style.display = 'block';
                        break;
                    case 0:
                        vs.style.display = 'block';
                        break;
                }
            }
        });
    };
}

// export { getProjectStatus };
